var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "my-box",
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-card",
            { attrs: { shadow: "always" } },
            [
              _c(
                "el-form",
                {
                  ref: "seekData",
                  staticClass: "topS",
                  attrs: { "label-width": "50px" },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "0px" },
                      attrs: { gutter: 10 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.selectOne },
                                  model: {
                                    value: _vm.seekData.brand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.seekData, "brand", $$v)
                                    },
                                    expression: "seekData.brand",
                                  },
                                },
                                _vm._l(
                                  _vm.brandSelectData,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.brandName,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "门店" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.selectTwo },
                                  model: {
                                    value: _vm.seekData.store,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.seekData, "store", $$v)
                                    },
                                    expression: "seekData.store",
                                  },
                                },
                                _vm._l(
                                  _vm.hotelSelectData,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "门店编号",
                                "label-width": "80px",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "my-input",
                                attrs: {
                                  placeholder: "请输入内容",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.seekData.hotelCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.seekData, "hotelCode", $$v)
                                  },
                                  expression: "seekData.hotelCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 2 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.seekData.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.seekData, "status", $$v)
                                    },
                                    expression: "seekData.status",
                                  },
                                },
                                _vm._l(_vm.options1, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "账号" } },
                            [
                              _c("el-input", {
                                staticClass: "my-input",
                                attrs: {
                                  placeholder: "请输入内容",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.seekData.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.seekData, "username", $$v)
                                  },
                                  expression: "seekData.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "真实姓名",
                                "label-width": "70px",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "my-input",
                                attrs: {
                                  placeholder: "请输入内容",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.seekData.fullName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.seekData, "fullName", $$v)
                                  },
                                  expression: "seekData.fullName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _vm.showadd != -1
                            ? _c("el-button", { on: { click: _vm.addBtn } }, [
                                _vm._v("新增"),
                              ])
                            : _vm._e(),
                          _vm.showdelete != -1
                            ? _c(
                                "el-button",
                                { on: { click: _vm.batchesDelete } },
                                [_vm._v("批量删除")]
                              )
                            : _vm._e(),
                          _vm.showreset != -1
                            ? _c(
                                "el-button",
                                { on: { click: _vm.resetPassword } },
                                [_vm._v("重置密码")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "创建时间",
                                "label-width": "70px",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "-",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy 年 MM 月 dd 日",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.createTime,
                                  callback: function ($$v) {
                                    _vm.createTime = $$v
                                  },
                                  expression: "createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最近登陆时间",
                                "label-width": "100px",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "-",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy 年 MM 月 dd 日",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.lastLoginTime,
                                  callback: function ($$v) {
                                    _vm.lastLoginTime = $$v
                                  },
                                  expression: "lastLoginTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "reset-button", attrs: { span: 8 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.reset } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-row"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-card", { attrs: { shadow: "always" } }, [
            _c(
              "div",
              { staticClass: "my-header-table" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      border: "",
                      "tooltip-effect": "dark",
                      height: _vm.height,
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "40" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "brand", label: "品牌" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "store", label: "门店" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "hotelCode",
                        label: "门店编号",
                        width: "80",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pmsHotelId",
                        label: "pms编号",
                        width: "80",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "roleName", label: "角色", width: "100" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "username", label: "账号", width: "150" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fullName",
                        label: "真实姓名",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "ssex", label: "性别", width: "50" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.ssex == 1
                                ? _c("span", [_vm._v("男")])
                                : scope.row.ssex == 0
                                ? _c("span", { attrs: { type: "info" } }, [
                                    _vm._v("女"),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "lastLoginTime",
                        label: "最近登陆时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "status", label: "状态", width: "70" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status == 1
                                ? _c("el-tag", [_vm._v("启用")])
                                : _c("el-tag", { attrs: { type: "info" } }, [
                                    _vm._v("停用"),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "210" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    dialogFormVisible: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDetails(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm.showupdate != -1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        dialogFormVisible: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              _vm.showdelete != -1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "prev, pager, next, sizes, total, jumper",
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.seekData.pageSize,
                    "current-page": _vm.seekData.pageNum,
                    total: _vm.total,
                  },
                  on: {
                    "current-change": _vm.handleCurrentChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "编辑用户", visible: _vm.dialogFormVisible2 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible2 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                rules: _vm.myrules,
                "label-width": "80px",
                model: _vm.editData,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌", prop: "brandId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.selectOne },
                              model: {
                                value: _vm.editData.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "brandId", $$v)
                                },
                                expression: "editData.brandId",
                              },
                            },
                            _vm._l(_vm.brandSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.brandName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店", prop: "storeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.selectTwo },
                              model: {
                                value: _vm.editData.storeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "storeId", $$v)
                                },
                                expression: "editData.storeId",
                              },
                            },
                            _vm._l(_vm.hotelSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "角色", prop: "roleId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.editData.roleId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "roleId", $$v)
                                },
                                expression: "editData.roleId",
                              },
                            },
                            _vm._l(_vm.roleSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.roleName,
                                  value: item.roleId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: { placeholder: "请输入内容", disabled: "" },
                            model: {
                              value: _vm.editData.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "username", $$v)
                              },
                              expression: "editData.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名", prop: "fullName" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入真实姓名",
                              clearable: "",
                            },
                            model: {
                              value: _vm.editData.fullName,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "fullName", $$v)
                              },
                              expression: "editData.fullName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: { placeholder: "请输入内容", clearable: "" },
                            model: {
                              value: _vm.editData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "email", $$v)
                              },
                              expression: "editData.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobile" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入联系电话",
                              clearable: "",
                            },
                            model: {
                              value: _vm.editData.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "mobile", $$v)
                              },
                              expression: "editData.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "座机号" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入办公电话",
                              clearable: "",
                            },
                            model: {
                              value: _vm.editData.oph,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "oph", $$v)
                              },
                              expression: "editData.oph",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别", prop: "ssex" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1", border: "" },
                                  model: {
                                    value: _vm.editData.ssex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editData, "ssex", $$v)
                                    },
                                    expression: "editData.ssex",
                                  },
                                },
                                [_vm._v("男")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "0", border: "" },
                                  model: {
                                    value: _vm.editData.ssex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editData, "ssex", $$v)
                                    },
                                    expression: "editData.ssex",
                                  },
                                },
                                [_vm._v("女")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "1",
                                    border: "",
                                    disabled: _vm.onoff,
                                  },
                                  model: {
                                    value: _vm.editData.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editData, "status", $$v)
                                    },
                                    expression: "editData.status",
                                  },
                                },
                                [_vm._v("启用")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "0",
                                    border: "",
                                    disabled: _vm.onoff,
                                  },
                                  model: {
                                    value: _vm.editData.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editData, "status", $$v)
                                    },
                                    expression: "editData.status",
                                  },
                                },
                                [_vm._v("停用")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "描述" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              placeholder: "请输入内容",
                            },
                            model: {
                              value: _vm.editData.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "description", $$v)
                              },
                              expression: "editData.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible2 = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.confirmEditD("editForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "新增用户", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                "label-position": "right",
                "label-width": "90px",
                rules: _vm.myrules,
                model: _vm.addform,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌", prop: "brandId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.selectOne },
                              model: {
                                value: _vm.addform.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addform, "brandId", $$v)
                                },
                                expression: "addform.brandId",
                              },
                            },
                            _vm._l(_vm.brandSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.brandName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店", prop: "storeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.selectTwo },
                              model: {
                                value: _vm.addform.storeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addform, "storeId", $$v)
                                },
                                expression: "addform.storeId",
                              },
                            },
                            _vm._l(_vm.hotelSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "角色", prop: "roleId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.addform.roleId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addform, "roleId", $$v)
                                },
                                expression: "addform.roleId",
                              },
                            },
                            _vm._l(_vm.roleSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.roleName,
                                  value: item.roleId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号", prop: "username" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: { placeholder: "请输入内容", clearable: "" },
                            model: {
                              value: _vm.addform.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "username", $$v)
                              },
                              expression: "addform.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "password" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.addform.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "password", $$v)
                              },
                              expression: "addform.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "确认密码", prop: "password2" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "确认密码",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.addform.password2,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "password2", $$v)
                              },
                              expression: "addform.password2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名", prop: "fullName" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入真实姓名",
                              clearable: "",
                            },
                            model: {
                              value: _vm.addform.fullName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "fullName", $$v)
                              },
                              expression: "addform.fullName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.addform.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "email", $$v)
                              },
                              expression: "addform.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobile" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入联系电话",
                              clearable: "",
                            },
                            model: {
                              value: _vm.addform.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "mobile", $$v)
                              },
                              expression: "addform.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "座机号", prop: "phone" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入办公电话",
                              clearable: "",
                            },
                            model: {
                              value: _vm.addform.oph,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "oph", $$v)
                              },
                              expression: "addform.oph",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1", border: "" },
                                  model: {
                                    value: _vm.addform.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addform, "status", $$v)
                                    },
                                    expression: "addform.status",
                                  },
                                },
                                [_vm._v("启用")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "0", border: "" },
                                  model: {
                                    value: _vm.addform.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addform, "status", $$v)
                                    },
                                    expression: "addform.status",
                                  },
                                },
                                [_vm._v("停用")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别", prop: "ssex" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1", border: "" },
                                  model: {
                                    value: _vm.addform.ssex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addform, "ssex", $$v)
                                    },
                                    expression: "addform.ssex",
                                  },
                                },
                                [_vm._v("男")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "0", border: "" },
                                  model: {
                                    value: _vm.addform.ssex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addform, "ssex", $$v)
                                    },
                                    expression: "addform.ssex",
                                  },
                                },
                                [_vm._v("女")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "描述" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              placeholder: "请输入内容",
                            },
                            model: {
                              value: _vm.addform.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "description", $$v)
                              },
                              expression: "addform.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.abrogateAdd } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.confirmAdd("addform")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "重置密码", visible: _vm.dialogFormVisible3 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible3 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "passwordData",
              attrs: {
                "label-position": "right",
                "label-width": "250px",
                rules: _vm.myrules,
                model: _vm.passwordData,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入内容",
                              clearable: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.passwordData.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.passwordData, "username", $$v)
                              },
                              expression: "passwordData.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名", prop: "fullName" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入真实姓名",
                              clearable: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.passwordData.fullName,
                              callback: function ($$v) {
                                _vm.$set(_vm.passwordData, "fullName", $$v)
                              },
                              expression: "passwordData.fullName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "password" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请输入",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.passwordData.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.passwordData, "password", $$v)
                              },
                              expression: "passwordData.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "确认密码", prop: "password4" } },
                        [
                          _c("el-input", {
                            staticClass: "my-input",
                            attrs: {
                              placeholder: "请再次输入密码",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.passwordData.password2,
                              callback: function ($$v) {
                                _vm.$set(_vm.passwordData, "password2", $$v)
                              },
                              expression: "passwordData.password2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.abrogateDassword } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.confirmDassword("passwordData")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "查看用户详情", visible: _vm.dialogTableVisible4 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible4 = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("用户名：" + _vm._s(_vm.gridData.username)),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("角色：" + _vm._s(_vm.gridData.roleName)),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("品牌：" + _vm._s(_vm.gridData.brand)),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("门店：" + _vm._s(_vm.gridData.store)),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("真实姓名：" + _vm._s(_vm.gridData.fullName)),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("邮箱：" + _vm._s(_vm.gridData.email)),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("电话号码：" + _vm._s(_vm.gridData.mobile)),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("座机号码：" + _vm._s(_vm.gridData.oph)),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v("创建时间：" + _vm._s(_vm.gridData.createTime)),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v(
                      "最近登陆时间：" + _vm._s(_vm.gridData.lastLoginTime)
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }